import React from 'react'

import NewClient from './NewClient'
import BackButton from '../UI/BackButton'
import PageTitle from '../UI/PageTitle'


const NewClientPage = () => (
  <section>
    <header>
      <PageTitle>New Client</PageTitle>
    </header>
    <NewClient showSuccessDialog={true} />
    <br/>
    <BackButton/>
  </section>
)

export default NewClientPage



// WEBPACK FOOTER //
// ./src/components/Clients/NewClientPage.jsx